module.exports = __webpack_public_path__ + "img/circle.8a6130dc.png";